import {
  DURACAO_SLOT_MIN,
  horarioDentroDaJanela,
  horarioDosMinutos,
  minutosDoHorario,
} from '@shared/horario';

import { DIAS_SEMANA } from '../dias-semana';

export type DiaValor = (typeof DIAS_SEMANA)[number]['valor'];

export interface DisponibilidadeProfessor {
  diasDisponiveis: string[];
  horarioInicial: string;
  horarioFinal: string;
}

export interface ProgramacaoDia {
  frequenta: boolean;
  horario: string;
}

export type ProgramacaoSemanal = Record<DiaValor, ProgramacaoDia>;

export function opcoesDeHorario(horarioInicial: string, horarioFinal: string): string[] {
  const inicio = minutosDoHorario(horarioInicial);
  const fim = minutosDoHorario(horarioFinal);
  const opcoes: string[] = [];
  for (let minutos = inicio; minutos < fim; minutos += DURACAO_SLOT_MIN) {
    opcoes.push(horarioDosMinutos(minutos));
  }
  return opcoes;
}

export function programacaoSemanalVazia(): ProgramacaoSemanal {
  return Object.fromEntries(
    DIAS_SEMANA.map((dia) => [dia.valor, { frequenta: false, horario: '08:00' }]),
  ) as ProgramacaoSemanal;
}

export function normalizarProgramacao(
  programacao: ProgramacaoSemanal,
  professor: DisponibilidadeProfessor,
): ProgramacaoSemanal {
  const primeiroHorario =
    opcoesDeHorario(professor.horarioInicial, professor.horarioFinal)[0] ??
    professor.horarioInicial;

  return Object.fromEntries(
    DIAS_SEMANA.map((dia) => {
      const valor = programacao[dia.valor];
      const diaDisponivel = professor.diasDisponiveis.includes(dia.valor);
      return [
        dia.valor,
        {
          frequenta: diaDisponivel && valor.frequenta,
          horario: horarioDentroDaJanela(
            valor.horario,
            professor.horarioInicial,
            professor.horarioFinal,
          )
            ? valor.horario
            : primeiroHorario,
        },
      ];
    }),
  ) as ProgramacaoSemanal;
}

export function programacaoValida(
  programacao: ProgramacaoSemanal,
  professor: DisponibilidadeProfessor,
): boolean {
  return DIAS_SEMANA.every((dia) => {
    const valor = programacao[dia.valor];
    return (
      !valor.frequenta ||
      (professor.diasDisponiveis.includes(dia.valor) &&
        horarioDentroDaJanela(valor.horario, professor.horarioInicial, professor.horarioFinal))
    );
  });
}
